import React from 'react';

export interface IMetricsTooltipItem {
  label: string;
  description: string;
}

interface IMetricsTooltipProps {
  items: IMetricsTooltipItem[];
}

export const MetricsTooltip: React.FC<IMetricsTooltipProps> = ({ items }) => {
  return (
    <ul className="m-0 pl-[22px] py-[5px] font-pt-sans text-[12px] text-black flex flex-col gap-[8px] pr-[8px]">
      {items.map(item => (
        <li key={item.label}>
          <span className="font-bold">{item.label}:</span> {item.description}
        </li>
      ))}
    </ul>
  );
};
